import { gql, MutationResult, useMutation } from '@apollo/client';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useCallback } from 'react';
import { MAYA_GRAPHQL_ENDPOINT } from 'basics/constants/common.constants';
import { extractApolloErrorDetails } from 'services/graphql/extractApolloErrorDetails';
import Logger from 'services/logger';

export const setCepStatusToRestoredMutationCall = gql`
  mutation setCepStatusToRestored($id: String!, $sendToVeeva: Boolean!) {
      setCepStatusToRestored(id: $id, sendToVeeva: $sendToVeeva)
  }
`;

export type MutationReturnType = {
  data: boolean;
  error: string | null;
};

type ApiResultType = {
  setCepStatusToRestored: boolean;
};

type UseSetCepStatusToRestoredMutation = [
  (
    id: string,
    sendToVeeva?: boolean
  ) => Promise<MutationReturnType>,
  MutationResult<ApiResultType>,
];

export const useSetCepStatusToRestoredMutation = (): UseSetCepStatusToRestoredMutation => {
  const [setCepStatusToRestored, state] = useMutation<ApiResultType>(setCepStatusToRestoredMutationCall, {
    fetchPolicy: 'network-only',
    context: { clientName: MAYA_GRAPHQL_ENDPOINT },
  });
  const flags = useFlags();

  const executeMutation = useCallback(async (id, sendToVeeva = true) => {
    try {
      const { data } = await setCepStatusToRestored({
        variables: {
          id,
          sendToVeeva: flags.mayaEnableVeevaBiogenlinc1816 && sendToVeeva,
        },
      });
      return { data: data?.setCepStatusToRestored || false, error: null };
    } catch (error: unknown) {
      if (error instanceof Error) {
        const customContext = extractApolloErrorDetails(error);
        Logger.logError({
          error,
          customContext,
          transactionName: 'setCepStatusToRestored.ts - useSetCepStatusToRestoredMutation',
        });
        return { data: false, error: customContext.message as string };
      }
      return { data: false, error: null };
    }
  }, [setCepStatusToRestored, flags.mayaEnableVeevaBiogenlinc1816]);

  return [executeMutation, state];
};
